import React from 'react';

import { Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';

import { Button } from '../../../components';

import './styles.scoped.css';

const wrapProjectCoverageTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'WC', label: 'WC' },
  { value: 'GL', label: 'GL' },
];

export const WrapOnsitePayrollReportForm = ({ form, handleChange, handleViewResults, handleCancel }) => (
  <div className="wrap-onsite-payroll-form">
    <Form>
      <div className="fields-container">
        <Row className="filter-row">
          <Col>
            <Form.Group as={Row} style={{ alignItems: 'center', gap: '12px' }}>
              <Form.Label> Check Paid Dates
                <div className="required"> *</div>
              </Form.Label>
              <Row>
                <Col>
                  <Form.Control
                    type="date"
                    name="PayrollCalculatedDateFrom"
                    value={form.PayrollCalculatedDateFrom}
                    onChange={handleChange}
                    placeholder="mm/dd/yyyy"
                    required
                  />
                </Col>
                <Col>
                  <Form.Control
                    type="date"
                    name="PayrollCalculatedDateTo"
                    value={form.PayrollCalculatedDateTo}
                    onChange={handleChange}
                    placeholder="mm/dd/yyyy"
                    required
                  />
                </Col>
              </Row>
            </Form.Group>
          </Col>
        </Row>

        <Row className="filter-row">
          <Col>
            <Form.Group as={Row} style={{ alignItems: 'center', gap: '12px' }}>
              <Form.Label>Wrap Project Coverage Type</Form.Label>
              <Select
                name="WrapProjectCoverageType"
                value={wrapProjectCoverageTypeOptions.find(option => option.value === form.WrapProjectCoverageType)}
                onChange={selectedOption => {
                  handleChange({
                    target: {
                      name: 'WrapProjectCoverageType',
                      value: selectedOption.value,
                    },
                  });
                }}
                options={wrapProjectCoverageTypeOptions}
                placeholder="Select coverage type"
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="filter-row">
          <Col>
            <Form.Group as={Row} style={{ alignItems: 'center', gap: '12px' }}>
              <Form.Label>Wrap Proj Project Full Name</Form.Label>
              <Form.Control
                style={{ width: '365px' }}
                type="text"
                name="WrapProjProjectFullName"
                value={form.WrapProjProjectFullName}
                onChange={handleChange}
                placeholder="Free text"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="filter-row">
          <Col>
            <Form.Group as={Row} style={{ alignItems: 'center', gap: '12px' }}>
              <Form.Label>Wrap Sub Project Name</Form.Label>
              <Form.Control
                style={{ width: '365px' }}
                type="text"
                name="WrapSubProjectName"
                value={form.WrapSubProjectName}
                onChange={handleChange}
                placeholder="Free text"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="filter-row">
          <Col>
            <Form.Group as={Row} style={{ alignItems: 'center', gap: '12px' }}>
              <Form.Label>Job Order Number</Form.Label>
              <Form.Control
                style={{ width: '365px' }}
                type="number"
                name="JobOrderNumber"
                value={form.JobOrderNumber}
                onChange={handleChange}
                placeholder="number only"
              />
            </Form.Group>
          </Col>
        </Row>
      </div>

      <div className="form-actions">
        <Button variant="primary" onPress={handleViewResults} text="Export" className="export-button" />
        <Button variant="warning" onPress={handleCancel} text="Cancel" className="cancel-button" />
      </div>
    </Form>
  </div>
);
